import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../redux/actions/configApi'; // Assumindo que a API está configurada nesse arquivo
import { useNavigate } from "react-router-dom";

// AsyncThunk para buscar as vendas
export const fetchVendas = createAsyncThunk('vendas/fetchVendas', async ({ page, searchTerm, sortDirection }, { rejectWithValue }) => {
    try {
        const response = await api.get(`/orders?page=${page}&search=${searchTerm}&sort=${sortDirection}`);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message);
    }
});

// AsyncThunk para atualizar o status de uma venda
export const updateStatusVenda = createAsyncThunk(
    'vendas/updateStatusVenda',
    async ({ id, status }, { rejectWithValue }) => {
        try {
            const response = await api.put(`/orders/${id}`, { status });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Erro ao atualizar status da venda');
        }
    }
);

export const emailConfirmacaoVenda = createAsyncThunk(
    'vendas/emailConfirmacaoVenda',
    async ({ order_code }, { rejectWithValue }) => {
        try {
            const response = await api.post(`/emailOrder`, { order_code });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Erro ao enviar e-mail');
        }
    }
);

export const emailConfirmacaoVendaStatus = createAsyncThunk(
    'vendas/emailConfirmacaoVendaStatus',
    async ({ order_code, status }, { rejectWithValue }) => {
        try {
            const response = await api.post(`/emailOrderStatus`, { order_code, status });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Erro ao enviar e-mail');
        }
    }
);


const vendasSlice = createSlice({

    name: 'vendas',
    initialState: {
        vendas: [],
        loading: false,
        error: null,
        message: '',
        total: '',
        //paginacao
        currentPage: 1,
        totalItems: 0,        // Total de registros no back-end     // Página atual
        itemsPerPage: 10,
        // Filtro e ordenação
        searchTerm: '',
        sortDirection: 'desc',
        successMessage: null,
    },
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
            state.currentPage = 1; // se quiser resetar para página 1 a cada busca
        },
        setSortDirection: (state, action) => {
            state.sortDirection = action.payload;
            state.currentPage = 1; // se quiser resetar para página 1 ao ordenar
        },
        /*clearUpdatedProposalId: (state) => {
            state.updatedProposalId = null;
        },*/
        clearMessages: (state) => {
            state.error = null;
            state.successMessage = null;
        },
    }, // Não precisamos de reducers síncronos aqui
    extraReducers: (builder) => {
        builder
            // Fetch Vendas
            .addCase(fetchVendas.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchVendas.fulfilled, (state, action) => {
                state.loading = false;
                state.totalItems = action.payload.total
                state.vendas = action.payload.orders;
            })
            .addCase(fetchVendas.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                const navigate = useNavigate();
                if (action.payload?.message === "Unauthenticated.") {
                    navigate("/login"); // Use a navegação do React Router
                }
            })
            // Update Status Venda
            .addCase(updateStatusVenda.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateStatusVenda.fulfilled, (state, action) => {
                state.loading = false;
                const { orders, message } = action.payload;
                console.log(orders,'orders')
                // Atualiza apenas a venda correspondente no array
                const index = state.vendas.findIndex(venda => venda.id === orders.id);
                if (index !== -1) {
                    state.vendas[index] = {
                        ...state.vendas[index],
                       ...orders
                    };
                }

                state.message = message;

            })
            .addCase(updateStatusVenda.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(emailConfirmacaoVenda.fulfilled, (state, action) => {
                state.message = 'Email enviado com sucesso';
                console.log(state.message, 'state.message')
                //state.error = action.payload;
            });
    },
});

export const {
    setCurrentPage,
    setSearchTerm,
    setSortDirection,
    clearMessages,
} = vendasSlice.actions;

export default vendasSlice.reducer;
